import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { ContentBody } from '../../../components/atoms/ContentBody/ContentBody';
import { DesktopIcon } from '../../../components/atoms/Icons/DesktopIcon';
import { ScreenWrapper } from '../../../components/atoms/ScreenWrapper/ScreenWrapper';
import { messages } from '../../messages';
import { useAnalytics } from '../../../core/Analytics/AnalyticsProvider';
import { PageView } from '../../../models/analytics';
import { StyledCenteredContainer, StyledText } from './HandoffCompletedScreen.styles';

type HandoffCompletedScreenProps = {
  clientName: string;
};

export const HandoffCompletedScreen: React.FC<HandoffCompletedScreenProps> = ({ clientName }) => {
  const { tinklinkAnalytics } = useAnalytics();

  useEffect(() => {
    tinklinkAnalytics.sendViewEvent({
      view: PageView.HANDOFF_COMPLETED_RESULT_SCREEN,
    });
  }, [tinklinkAnalytics]);

  return (
    <ScreenWrapper>
      <ContentBody centerVertically>
        <StyledCenteredContainer>
          <DesktopIcon />
          <StyledText>
            <FormattedMessage {...messages['HandoffCompleted.done']} values={{ clientName }} />
          </StyledText>
        </StyledCenteredContainer>
      </ContentBody>
    </ScreenWrapper>
  );
};
